import {Close} from '@mui/icons-material';
import {Box, Chip, Tooltip} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';
import {arrayOf, bool, func, string} from 'prop-types';

import {userShape} from '../../proptypes-shapes';
import {capitalizeWord} from '../../utils';

const UsersContainer = muiStyled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  padding: '8px'
}));

const UsersChipsList = ({users, onDelete, onClick, isDisabled = false, showDeleteIcon = true, selectedUserId = ''}) => {
  if (!users?.length) return null;

  const getTooltip = user => {
    return user.user_id.includes('pending-user') ? "Utilisateur en attente d'inscription" : user.mail;
  };

  const getLabel = user => {
    return user.user_id.includes('pending-user') ? user.username : user.username.split(' ').map(capitalizeWord).join(' ');
  };

  return (
    <UsersContainer>
      {users.map((user, index) => {
        const {user_id: userId} = user;

        const chip = (
          <Chip
            key={index}
            color="primary"
            variant={selectedUserId === userId ? 'contained' : 'outlined'}
            sx={{mr: 1, mb: 1, cursor: 'pointer'}}
            label={getLabel?.(user) ?? user.username}
            disabled={isDisabled}
            onClick={onClick ? e => onClick(e, userId) : undefined}
            onDelete={onDelete ? () => onDelete(userId) : undefined}
            deleteIcon={showDeleteIcon ? <Close fontSize="small" color="primary" /> : undefined}
          />
        );

        const tooltipTitle = getTooltip?.(user);
        return tooltipTitle ? (
          <Tooltip
            placement="bottom"
            PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -15]
                  }
                }
              ]
            }}
            key={index}
            title={tooltipTitle}
          >
            <span>{chip}</span>
          </Tooltip>
        ) : (
          chip
        );
      })}
    </UsersContainer>
  );
};

UsersChipsList.propTypes = {
  users: arrayOf(userShape).isRequired,
  onDelete: func,
  onClick: func,
  isDisabled: bool || func,
  // eslint-disable-next-line react/boolean-prop-naming
  showDeleteIcon: bool,
  selectedUserId: string
};

export default UsersChipsList;
